import axios from 'axios'
import { getToken } from '@/utils/auth'

// One /teacher/center/me request per token; failures resolve to null (menu hidden).
let centerMeRequest = null
let centerMeToken = null
export function fetchCenterMe() {
  const token = getToken()
  if (!token) return Promise.resolve(null)
  if (centerMeRequest && centerMeToken === token) return centerMeRequest
  centerMeToken = token
  centerMeRequest = axios
    .get(`${process.env.VUE_APP_V2_BASE_API}/teacher/center/me`, {
      headers: { Authorization: 'Bearer ' + token },
      timeout: 15000
    })
    .then((res) => res.data || null)
    .catch(() => {
      centerMeRequest = null
      return null
    })
  return centerMeRequest
}

// Center settings: managers, once the platform has granted the module.
export function canOpenCenterSettings(me) {
  return !!me && me.enabled && (me.roles || []).includes('manager')
}

// The center "Lớp học" (v2) replaces the LMS class list once the platform has
// granted the module (web only; v2 is not bundled in the mobile app).
export function hasCenterClasses(me, device) {
  return !!me && me.enabled && device !== 'isMobileApp'
}

// True when the v1 class is set up in the center (it has a center detail page).
// Silent: a 404 (plain LMS class) or any failure just means "no".
export function isCenterClass(classId) {
  const token = getToken()
  if (!token || !classId) return Promise.resolve(false)
  return axios
    .get(`${process.env.VUE_APP_V2_BASE_API}/teacher/center/classes/${classId}`, {
      headers: { Authorization: 'Bearer ' + token },
      timeout: 10000
    })
    .then(() => true)
    .catch(() => false)
}

// The center "Học viên" (v2) replaces the LMS Học sinh list for the roles that
// see it in the menu (same rule as App.vue CENTER_MENU: manager, academic,
// sale, accountant); plain teachers keep the LMS list.
const CENTER_STUDENT_ROLES = ['manager', 'academic', 'sale', 'accountant']
export function hasCenterStudents(me, device) {
  return (
    hasCenterClasses(me, device) &&
    (me.roles || []).some((r) => CENTER_STUDENT_ROLES.includes(r))
  )
}
